import { QrCode } from 'lucide-react'
import { useCallback, useState } from 'react'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/shared/ui/dialog'
import { QrGenerator } from './qr-generator'

interface QrGeneratorDialogProps {
  data: string
  label: string
  triggerClassName?: string
}

export function QrGeneratorDialog({
  data,
  label,
  triggerClassName = 'w-full',
}: QrGeneratorDialogProps) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)

  // Radix unmounts the generator on close, which would strand a paid generation:
  // the credits are spent but the result never reaches the user.
  const handleOpenChange = useCallback(
    (next: boolean) => {
      if (!next && busy) return
      setOpen(next)
    },
    [busy],
  )

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button variant="outline" className={triggerClassName}>
          <QrCode className="mr-2 h-4 w-4" />
          {m.qrCode()}
        </Button>
      </DialogTrigger>
      <DialogContent showCloseButton={!busy} className="max-h-[85vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{m.qrCode()}</DialogTitle>
          <DialogDescription>{m.qrDialogDescription({ name: label })}</DialogDescription>
        </DialogHeader>
        <QrGenerator presetData={data} presetLabel={label} onBusyChange={setBusy} />
      </DialogContent>
    </Dialog>
  )
}
